import { AsyncResult } from '../types/AsyncResult';
import { Validator } from '../util/parse';

export type Experiment<T> = {
  mbox: string;
  validate: Validator<T>;
  parameters?: Record<string, string>;
};

export type ExperimentCache = Record<string, undefined | { value: unknown }>;

export const makeExperimentWithData = <T>(
  mbox: string,
  validate: Validator<T>,
  parameters?: Record<string, string>,
): Experiment<T> => ({
  mbox,
  validate,
  parameters,
});

export const makeSimpleExperiment = (
  mbox: string,
  parameters?: Record<string, string>,
): Experiment<unknown> => ({
  mbox,
  validate: validateUnknown,
  parameters,
});

const validateUnknown = (_value: unknown): _value is unknown => true;

/** The type returned from useExperiment() */
export type ExperimentResult<T> = T extends Experiment<infer Data> ? AsyncResult<Data> : never;
